/* ============================================================
   OooWee Deals — Shopify theme config
   Plug your Klaviyo keys here. Gets loaded on every page via
   theme.liquid (or any section that includes oooweedeals.js).
   ============================================================ */
window.OW_CONFIG = {
  KLAVIYO_PUBLIC_KEY:   "",
  KLAVIYO_LIST_MEMBERS: "",
  KLAVIYO_LIST_SPIN:    ""
};
